import { render, staticRenderFns } from "./SuggestPopup.vue?vue&type=template&id=65527c3e&scoped=true"
import script from "./SuggestPopup.vue?vue&type=script&lang=js"
export * from "./SuggestPopup.vue?vue&type=script&lang=js"
import style0 from "./SuggestPopup.vue?vue&type=style&index=0&id=65527c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65527c3e",
  null
  
)

export default component.exports